import { StateCreator } from 'zustand';
import {
  GifEmbedAssetSlice,
  GifEmbedAssetState,
  GifPickerDomainState,
  GifPickerSlice,
} from './index.types';

export const DEFAULT_GIF_EMBED_ASSET: GifEmbedAssetState = {
  status: 'loading',
  imageUrl: null,
  mp4Url: null,
  webmUrl: null,
  posterUrl: null,
  altText: 'GIF',
};

export const EMPTY_GIF_ID_ASSET: GifEmbedAssetState = {
  ...DEFAULT_GIF_EMBED_ASSET,
  status: 'unavailable',
};

export const createGifEmbedAssetSlice: StateCreator<GifEmbedAssetSlice> = (
  set
) => ({
  gifEmbedAssetsById: {},
  setGifEmbedAsset: (gifId, partial) =>
    set((state) => {
      const key = gifId.trim();
      const prev =
        state.gifEmbedAssetsById[key] ?? DEFAULT_GIF_EMBED_ASSET;
      return {
        gifEmbedAssetsById: {
          ...state.gifEmbedAssetsById,
          [key]: { ...prev, ...partial },
        },
      };
    }),
  resetGifEmbedAssets: () => set({ gifEmbedAssetsById: {} }),
});

const initialGifPickerDomain: GifPickerDomainState = {
  isOpen: false,
  searchQuery: '',
  debouncedQuery: '',
  gifs: [],
  loading: false,
  loadingMore: false,
  error: null,
  searchHasMore: false,
  searchLastPage: 0,
};

export const createGifPickerSlice: StateCreator<GifPickerSlice> = (set) => ({
  gifPicker: { ...initialGifPickerDomain, gifs: [] },
  setGifPicker: (partial) =>
    set((state) => ({
      gifPicker: { ...state.gifPicker, ...partial },
    })),
  resetGifPicker: () =>
    set({
      gifPicker: { ...initialGifPickerDomain, gifs: [] },
    }),
});
